import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BrowseModule } from 'common/views/browse/browse.module';
import { QuickLinksModule } from 'common/components/quick-links/quick-links.module';
import { ContentModule } from 'common/content/content.module';
import { RichTextModule } from 'common/pipes/rich-text/rich-text.module';
import { ComponentsModule } from 'public/app/components/components.module';
import { SafePipeModule } from 'safe-pipe';
import { QuickLinksService } from '../../../../common/services/quickLinks.service';
import { LandingComponent } from './components/landing/landing.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

@NgModule({
    imports: [
        BrowseModule,
        CommonModule,
        ContentModule,
        FormsModule,
        ReactiveFormsModule,
        HomeRoutingModule,
        ComponentsModule,
        TranslateModule,
        SafePipeModule,
        RichTextModule,
        QuickLinksModule
    ],
    declarations: [
        HomeComponent,
        LandingComponent
    ],
    providers: [
        QuickLinksService
    ]
})
export class HomeModule {}
